const MESSENGER_NAME = 'messenger';

/**
 * ÐŸÐ¾Ð»Ð¸Ñ„Ð¸Ð»Ð» Ð´Ð»Ñ findIndex
 * @param {Array} array
 * @param {Function} cb Ð¤ÑƒÐ½ÐºÑ†Ð¸Ñ ÑÑ€Ð°Ð²Ð½ÐµÐ½Ð¸Ñ
 */
const findIndex = (array, cb) => array
    .map((item, i) => ({ item, i }))
    .filter(({ item }) => cb(item))
    .map(({ i }) => i)[0];

/**
 * Ð“Ð¾Ñ‚Ð¾Ð²Ð¸Ñ‚ ÑÐµÑ€Ð²Ð¸ÑÑ‹ Ðº Ð¾Ñ‚Ð¿Ñ€Ð°Ð²ÐºÐµ Ð² ÑˆÐ°Ð±Ð»Ð¾Ð½Ð¸Ð·Ð°Ñ‚Ð¾Ñ€
 * @param {string[]} services
 * @param {Object} options
 * @param {number} options.limit
 * @param {boolean} options.needExtendMessenger
 * @returns {Object}
 */
export function prepareServicesList(services, options) {
    const { limit, needExtendMessenger } = options;

    if (needExtendMessenger && limit !== undefined) {
        services = services.slice(0);
        const yandexMessengerIndex = findIndex(services, item => item.toLowerCase() === MESSENGER_NAME);

        if (yandexMessengerIndex !== undefined) {
            services.splice(yandexMessengerIndex, 1);
        }

        services.splice(limit, 0, MESSENGER_NAME);
    }

    return services;
}
